export const EMPLOYMENT_STATUS = {
  FULL_TIME: 'EMPLOYED',
  SELF_EMPLOYED: 'SELF_EMPLOYED',
};
